enum AddUsersType {
  AddExistingUsers = 'ADD_EXISTING_USERS',
  InviteNewUsers = 'INVITE_NEW_USERS',
}

export default AddUsersType;
